export default __webpack_public_path__ + "static/media/home-seo-agency-img-03.e7135970.jpg";